// The Face ID sheet is system UI drawn over the app, and iOS reports it as
// the app resigning and regaining active - the same signals as a real trip
// to the background. Without this, our own prompt made AppLifecycleHandler
// lock the session on the way in and, if the sheet stayed up longer than the
// "glance away" window, prompt AGAIN on the way out: two Face ID sheets in a
// row on every cold start on 1.129. Every caller of BiometricAuth.authenticate
// wraps it here, and the lifecycle handler ignores state changes that happen
// while a prompt of ours is on screen.
let inFlight = false;

export const isBiometricPromptInFlight = (): boolean => inFlight;

export const withBiometricPrompt = async <T>(run: () => Promise<T>): Promise<T> => {
  inFlight = true;
  try {
    return await run();
  } finally {
    // Leave the flag up for a beat: the sheet's dismissal animation delivers
    // its didBecomeActive AFTER the promise resolves.
    setTimeout(() => { inFlight = false; }, 750);
  }
};
